import { Form, Formik } from "formik";
import React, { useContext, useState } from "react";
import * as Yup from "yup";
import InnerLayout from "../../components/layouts/inner-layout";
import InputField from "../../components/forms/input-field";
import AddButton from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import { api } from "../../redux/apis/api";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";
import AccessDenied from "../../components/helper-components/access-denied";
import { DataContext } from "../../components/layouts/main-layout";

const AddUserCreation = () => {
  const { permissionFn } = useContext(DataContext);
  // Same access check as Price List: the page needs "create" on
  // user_creation and shows AccessDenied without it.
  const hasAccess = permissionFn("user_creation")?.create === true;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    user_name: "",
    store_app_use_phone_number: "",
  };

  const validationSchema = Yup.object().shape({
    user_name: Yup.string().required("User Name is required"),
    store_app_use_phone_number: Yup.string()
      .matches(/^\d{10}$/, "Enter a valid 10-digit mobile number")
      .required("Phone Number is required"),
  });

  const onSubmit = (values) => {
    setLoading(true);
    api
      .post("/cpos/app/user/registration", values)
      .then((res) => {
        setLoading(false);
        successToast("User created successfully");
        navigate("/user-creation", { state: { newUser: values } });
      })
      .catch((err) => {
        setLoading(false);
        errorToast(
          err?.response?.data?.message ?? "Failed to create user"
        );
      });
  };

  if (!hasAccess) {
    return (
      <InnerLayout title="Add User" backBtn={true}>
        <AccessDenied message="You don't have permission to create users." />
      </InnerLayout>
    );
  }

  return (
    <InnerLayout title="Add User">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="h-full flex flex-col justify-between">
            <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 pt-5">
              <InputField
                type="text"
                name="user_name"
                placeholder="Enter the user's full name"
                label="User Name"
                isRequired={true}
                labelWidth="10.5rem"
              />
              <InputField
                type="text"
                name="store_app_use_phone_number"
                placeholder="Enter 10-digit mobile number"
                label="Phone Number"
                isRequired={true}
                labelWidth="10.5rem"
              />
            </div>
            <div
              className="flex justify-end px-10 mb-5 sticky bg-white py-4 invoice-bottom-container"
              style={{ bottom: 0 }}
            >
              <div className="flex gap-3">
                <button
                  type="button"
                  className="px-6 py-2 rounded-md border border-gray-300 text-sm fw_500"
                  onClick={() => navigate("/user-creation")}
                >
                  Cancel
                </button>
                <AddButton
                  prefixIcon={false}
                  text={loading ? "Saving..." : "Save User"}
                  type="submit"
                  isDisabled={loading || isSubmitting}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </InnerLayout>
  );
};

export default AddUserCreation;